import { pluginApi } from 'services/api';
import { ApiAction } from './interfaces';

export default async (data: ApiAction): Promise<void> => {
  await pluginApi.post(`/strategy-action/add`, {
    ...data,
    status_strategy_action_id: 1,
  });
};
